<template>
  <div class="form-group">
    <h3>Step {{ currentStep }}. Visa Status</h3>
    <div class="form-row">
      <div class="form-gap">Have you received your visa?</div>
    </div>

    <div class="form-row">
      <div class="radiolabel" :class="{ on: modelValue === true }" @click="$emit('update:modelValue', true)">
        <div class="radio" />
        <label>Yes</label>
      </div>
    </div>

    <div class="form-row">
      <div class="radiolabel" :class="{ on: modelValue === false }" @click="$emit('update:modelValue', false)">
        <div class="radio" />
        <label>No</label>
      </div>
    </div>

    <div class="form-row">
      <div class="radiolabel" :class="{ on: modelValue === 'eta' }" @click="$emit('update:modelValue', 'eta')">
        <div class="radio" />
        <label>I have confirmed that I do not need a visa</label>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  currentStep: {
    type: Number,
    required: true,
  },
  modelValue: {
    type: [Boolean, String],
    default: null,
  },
});

defineEmits(["update:modelValue"]);
</script>
